<template>
  <div class="animated fadeIn">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col sm="12" class="text-right">
            <a href="#" @click="exportCsv">Exportar em .csv</a>
          </b-col>
        </b-row>
        <b-row style="margin-top: 20px;">
          <b-col sm="12">
            <b-table :striped="true" :bordered="true" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="20">
              <template #cell(page)="data">
                <div>
                  {{data.item.page ? data.item.page : "-"}}
                </div>
              </template>
              <template #cell(insertionDate)="data">
                <div>
                  {{data.item.insertionDate | moment("DD/MM/YYYY HH:mm")}}
                </div>
              </template>
            </b-table>
          </b-col>
          <b-col sm="12" class="text-center">
            <b-pagination
                v-if="items && items.length"
                :total-rows="items.length"
                :per-page="20"
                v-model="currentPage"
                prev-text="Anterior"
                next-text="Próxima"
                align="center"
              ></b-pagination>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";
import config from "../config"


export default {
  name: 'SiteLeads',
  data () {
    return {
      isMobile: isMobile,
      currentPage: 0,
      fields: [
        {
          label: 'Email',
          key: "email"
        },
        {
          label: 'Whatsapp',
          key: "whatsapp"
        },
        {
          label: 'Data da Inscrição',
          key: "insertionDate"
        },
        {
          label: 'Página',
          key: "page"
        }
      ],
      items: []
    }
  },
  computed: {

  },
  methods: {
    getLeads: function() {
      service.getSiteSubscriptions().then((result) => {this.items = result.leads})
    },
    exportCsv: function() {
      window.location.href = config.BASE_API_URL + "site-subscriptions-report/" +  localStorage.sessionId
    }
  },
  created() {
    this.getLeads();
  }
}
</script>

<style scoped>

</style>
